import axios from "axios"
import {
  CREATE_TANK_SUPPLY_PERMIT,
  REQUEST_TANKS_DATA,
  RESET_SUCCESS,
  ADD_TANK_MODE,
  SET_ERROR,
  TANK_ASSIGNED,
  REMOVE_TANK_ASSIGNED,
  DELETE_TANK_SUPPLY_PERMIT,
  RESET_LOADING,
  CLEAN_ERROR,
  EDIT_TANK_MODE,
  TANK_SELECTED,
  CHECK_UNIT_SUPPLY_PERMIT,
  GET_TANKS_SUPPLY_PERMIT,
  RESET_TANK_SELECTED
} from "redux/reducers/tanks/tanksReducer";
import { getUnitsConfigs } from "../unitsSection/unitsAction"
import { api_get, api_post, api_put } from "services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import { tanksCases } from "redux/reducers/tanks/types";

const {
  TANKS_INPUTS,
  GET_TANKS,
  FILTER_TANKS,
  CREATE_TANK,
  EDIT_TANK
} = tanksCases

export const setTanksInputs = (key = "", value) => {
  return {
    type: TANKS_INPUTS,
    payload: { value, key }
  }
}

export const getTanks = () => {
  const url = `${process.env.REACT_APP_URL}/tanks`
  return async (dispatch) => {
    dispatch(startRequestComp("loadingTanks"))
    await api_get(url).then(resp => {
      dispatch({
        type: GET_TANKS,
        payload: resp
      })
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp("loadingTanks"))
  }
}

export const setFilterTanks = () => {
  return {
    type: FILTER_TANKS
  }
}

export const updateTankAvailable = (ids) => {
  return {
    type: TANK_ASSIGNED,
    payload: ids
  }
}

export const setTankAvailable = (ids) => {
  return {
    type: REMOVE_TANK_ASSIGNED,
    payload: ids
  }
}

export const tankSelected = (id) => {
  return {
    type: TANK_SELECTED,
    payload: id
  }
}

export const addTankMode = () => {
  return {
    type: ADD_TANK_MODE,
  }
}
export const editTankMode = () => {
  return {
    type: EDIT_TANK_MODE,
  }
}

export const resetTankSelected = () => {
  return {
    type: RESET_TANK_SELECTED
  }
}
export const createNewTank = (form, idStation, action = null) => {
  const url = `${process.env.REACT_APP_URL}/tanks`
  return async (dispatch) => {
    dispatch(startRequestComp("loadingModTank"))
    await api_post(url, form).then(resp => {
      dispatch({
        type: CREATE_TANK,
        payload: { ...resp, assigned: 0, id_station: idStation  }
      })
      dispatch(setSnackbar("Tanque creado correctamente", "success"))
      action && action()
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp("loadingModTank"))
  }
}

export const editTank = (id, form, action = null) => {
  const url = `${process.env.REACT_APP_URL}/tanks/${id}`
  return async (dispatch) => {
    dispatch(startRequestComp("loadingModTank"))

    await api_put(url, form).then(resp => {
      dispatch({
        type: EDIT_TANK,
        payload: { ...resp, id }
      })
      dispatch(setSnackbar("Tanque editado correctamente", "success"))
      action && action()
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp("loadingModTank"))
  }
}

//SUPPLIES

export const getSuppliesPermit = (token) => {
  const url = `${process.env.REACT_APP_URL}/tanks/supply`
  const headers = { headers: { Authorization: token } }
  let payload = {}
  return async (dispatch) => {
    dispatch({ type: REQUEST_TANKS_DATA })

    await axios.get(url, headers).then(resp => {
      payload = {
        type: GET_TANKS_SUPPLY_PERMIT,
        payload: resp.data
      }
      dispatch(payload)
    }).catch(error => {
      const err = error.response.data?.message.error
      dispatch({
        type: SET_ERROR,
        payload: err
      })
      dispatch({
        type: RESET_LOADING,
      })
    })
  }
}

export const createSupplyPermit = (form, token, station) => {
  const url = `${process.env.REACT_APP_URL}/tanks/supply`
  let payload = {}

  return async (dispatch) => {
    dispatch({ type: REQUEST_TANKS_DATA })

    await axios.post(url, form).then(resp => {
      // if(Object.keys(resp.data).length > 0) {
      payload = {
        type: CREATE_TANK_SUPPLY_PERMIT,
        payload: resp.data
      }
      dispatch(payload)
    }).then(() => {
      dispatch(getUnitsConfigs(station, token))
      dispatch(getTanks(token))
    }).catch(error => {
      const err = error?.response.data?.message.error || 'error'
      dispatch({
        type: SET_ERROR,
        payload: err
      })
      dispatch({
        type: RESET_LOADING,
      })
    })
  }
}


export const removeTankFromUnit = (form, _token) => {
  const url = `${process.env.REACT_APP_URL}/tanks/supply`
  // const headers = { headers: {Authorization: token }, ...form }
  let payload = {}
  return async (dispatch) => {
    // dispatch({ type: REQUEST_TANKS_DATA })
    await axios.delete(url, { data: { ...form } }).then(resp => {
      payload = {
        type: DELETE_TANK_SUPPLY_PERMIT,
        payload: resp.data.id_tank
      }
      dispatch(payload)
    }).catch(error => {
      const err = error.response.data?.message.error
      dispatch({
        type: SET_ERROR,
        payload: err
      })
      dispatch({
        type: RESET_LOADING,
      })
    })
  }
}


export const checkUnitSupply = (id, form, token) => {
  const url = `${process.env.REACT_APP_URL}/tanks/supply/${id}`
  const headers = { headers: { Authorization: token }, ...form }
  let payload = {}
  return async (dispatch) => {
    dispatch({ type: REQUEST_TANKS_DATA })

    await axios.post(url, headers).then(resp => {
      payload = {
        type: CHECK_UNIT_SUPPLY_PERMIT,
        payload: resp.data
      }
      dispatch(payload)
    }).catch(error => {
      const err = error.response.data?.message.error
      dispatch({
        type: SET_ERROR,
        payload: err
      })
      dispatch({
        type: RESET_LOADING,
      })
    })
  }
}



export const resetSuccess = () => {
  return {
    type: RESET_SUCCESS
  }
}
export const resetError = () => {
  return {
    type: CLEAN_ERROR
  }
}